import { createClient } from "@supabase/supabase-js";
import type { Database } from "../../types/supabase";

// Get Supabase credentials from environment variables or use fallback for development
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://supamozo.live';
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsImlhdCI6MTc0ODk2OTgyMCwiZXhwIjo0OTA0NjQzNDIwLCJyb2xlIjoic2VydmljZV9yb2xlIn0.EX5-p5sLsCHE-IWpPkh_9dXIg-GjlyRtxteWE1XDK20';

// If credentials are still missing after fallback, log a warning
if (!supabaseUrl || !supabaseServiceKey) {
  console.warn("Missing Supabase service role credentials. Admin operations will fail.");
}

// Create a Supabase client with service role key for admin operations
export const supabaseAdmin = createClient<Database>(
  supabaseUrl,
  supabaseServiceKey,
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
    global: {
      headers: {
        "x-application-name": "mozo-live-admin",
      },
    },
  }
);

export default supabaseAdmin;
